import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Divider from 'src/components/ui/Divider/Divider';
import Button, { ButtonToneProps } from 'src/components/ui/Button/Button';
import { ReturnsCreateShell } from './ReturnsCreateTracking';
import { ActionBar, Section, SectionHeadline } from './ReturnsConfiguratorForm';
import WarningBox, { WarningBoxColorType } from '../../components/ui/WarningBox/WarningBox';

const ReturnsCreateDone: React.FC<{}> = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <ReturnsCreateShell step={4} title={t('navbar.returns')} headline={t('navbar.create_return')}>
      <div className="grid gap-y-20">
        <Section className="flex flex-col gap-y-32">
          <WarningBox
            colorType={WarningBoxColorType.Successful}
            title={t('general.successful')}
            icon="checkmark"
            copy={t('returns.return_created')}
            isReturn
          />
          <Section>
            <div className="flex flex-col items-start gap-[12px]">
              <SectionHeadline>{t('returns.label')}</SectionHeadline>
              <div className="w-full">
                <WarningBox
                  colorType={WarningBoxColorType.Warning}
                  title={t('general.information')}
                  icon="warning"
                  copy={t('returns.label_information')}
                  isReturn
                />
              </div>
            </div>
          </Section>

          <Divider className="" />
          <ActionBar>
            <Button
              title={t('returns.back_to_overview')}
              tone={ButtonToneProps.SECONDARY}
              onClick={() => {
                navigate('/returns');
              }}
            />
          </ActionBar>
        </Section>
      </div>
    </ReturnsCreateShell>
  );
};

export default ReturnsCreateDone;
